import React from "react";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import "react-tabs/style/react-tabs.css";
import "assets/scss/responsive.css";
import "./customstyle.css";
import CustomerSummary from "./CustomerSummary";

class CustomerAudience extends React.Component {

    constructor(props) {
    super(props);
    this.state = {
        errors: this.props.errors
    }
  }

  render() {
    return (
        <div>

        <GridContainer style={{display: "inline-block", width:"35vw", paddingBottom: "60px !important"}} >
          <GridItem xs={12} sm={12} md={12} xl={12} style={{height:"50vh"}}>
            <Card>
                <div className="filtercentercontent summarycontent">
                <div className="filteraudiencetitle summarytitle">
                  <h2 className="capitalize">Properties</h2>
                </div>
              <CardBody style={{height:"35vh"}}>
                 <div style={{paddingTop: "20px"}}>
                   <CustomInput
                    labelText="Title"
                    id="groupTitle"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: event => this.props.handleChangeInput(event, "groupTitle"),
                      value: this.props.groupTitle
                    }}
                  />
                  <span className="redColor">{this.props.errors["groupTitle"]}</span>
                  <br/>
                  <CustomInput
                    labelText="Description"
                    id="listDescription"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: event =>
                        this.props.handleChangeInput(event, "listDescription"),
                      value: this.props.listDescription
                    }}
                  />
                  <span className="redColor">
                    {this.props.errors["listDescription"]}
                  </span>
                </div>
              </CardBody>
              </div>
            </Card>
          </GridItem>
        </GridContainer>
         


        <CustomerSummary editMode={this.props.id} />
        </div>
        // </CardBody>
        // {/* <CardFooter /> */}
        // </Card>
    );
}

}


const mapStateToProps = state => ({
    /*count: state.count,
    tillSqlSelectionArr: state.tillSqlSelectionArr,
    afterSqlSelectionArr: state.afterSqlSelectionArr,
    ruleLeveltoggle: state.ruleLeveltoggle,
    groupLeveltoggle: state.groupLeveltoggle,
    title: state.title,
    listDescription: state.listDescription,
    queryCount: state.queryCount,
    showQuerySpinner: state.showQuerySpinner,
    previewData: state.previewData,
  
    countSegment: state.countSegment,
    tillSqlSelectionArrSegment: state.tillSqlSelectionArrSegment,
    afterSqlSelectionArrSegment: state.afterSqlSelectionArrSegment,
    ruleLeveltoggleSegment: state.ruleLeveltoggleSegment,
    groupLeveltoggleSegment: state.groupLeveltoggleSegment,
  
    queryCountSegment: state.queryCountSegment,
    showQuerySpinnerSegment: state.showQuerySpinnerSegment,
    previewDataSegment: state.previewDataSegment,
    segmentName: state.segmentName,
    segmentData: state.segmentData,
    hideTabs: state.hideTabs,
    sliderValue: state.sliderValue,
    queryCountTempSegment: state.queryCountTempSegment*/
  });

export default connect(mapStateToProps)(
    withStyles(notificationsStyle)(CustomerAudience)
  );
  


// WEBPACK FOOTER //
// ./src/views/Audiences/CustomerAudience.jsx